import useUiPreferenceCache from "@apps/use-ui-preference-cache/use-ui-preference-cache";
import { mobileSidebarOpenVar } from "@cache/cache";
import Button from "@components/button/button";
import { ButtonSize, buttonTheme } from "@components/button/button-constants";
import { getTopicflowIcon } from "@components/topicflow-icon/topicflow-icon-helpers";
import { toggleSidebarShortcutLabel } from "@helpers/helpers";

const LayoutLeftIcon = getTopicflowIcon("layoutLeft");

const ShowSidebarButton = () => {
  const { uiPreferenceCache, saveUiPreference } = useUiPreferenceCache();
  const expanded = uiPreferenceCache.leftNavigationSidebarExpanded;
  const showSidebarTooltip = `Show sidebar: ${toggleSidebarShortcutLabel()}`;

  return (
    <>
      <span className="md:hidden">
        <Button
          icon={LayoutLeftIcon}
          theme={buttonTheme.iconGray}
          size={ButtonSize.medium}
          onClick={() => mobileSidebarOpenVar(true)}
          aria-label="Show sidebar"
          tooltip={showSidebarTooltip}
        />
      </span>
      {!expanded && (
        <span className="hidden md:inline-block">
          <Button
            icon={LayoutLeftIcon}
            theme={buttonTheme.iconGray}
            size={ButtonSize.medium}
            onClick={() =>
              saveUiPreference({ leftNavigationSidebarExpanded: true })
            }
            aria-label="Show sidebar"
            tooltip={showSidebarTooltip}
          />
        </span>
      )}
    </>
  );
};

export default ShowSidebarButton;
